import React from 'react';
import {
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../ui/Table';
import { DownFilled, FileArrowDown, FolderOpenIcon } from '../../icons';
import clsx from 'clsx';
import { Rounded } from '../elements/rounded';
import { NoDataFound } from '../elements/noDataFound';

export const TableHeadersComponent = ({
  tableData,
  selectedColumns,
  handleSortOrder,
}) => {
  const createHeaders = () => {
    const { columns } = tableData;
    let headers = [];

    if (columns && columns.length) {
      columns.map((itm, idx) => {
        if (!selectedColumns.includes(itm.name)) {
          let headerTemplate = itm.label;
          if (itm.ordering) {
            headerTemplate = (
              <button
                type="button"
                className="cursor-pointer flex "
                onClick={() => handleSortOrder(itm)}
              >
                <h5 className="whitespace-nowrap text-body-large">
                  {headerTemplate}
                </h5>
                <span className="sort">
                  <DownFilled className={clsx('fill-[#595454] h-6 w-6')} />
                </span>
              </button>
            );
            headers.push(
              <TableHead key={itm.label} scope="col">
                {headerTemplate}
              </TableHead>
            );
          } else {
            headers.push(
              <TableHead key={itm.label} scope="col">
                <h5 className="whitespace-nowrap text-body-large">
                  {headerTemplate}
                </h5>
              </TableHead>
            );
          }
        }
      });

      return (
        <TableHeader>
          <TableRow>{headers}</TableRow>
        </TableHeader>
      );
    }
  };

  return <>{createHeaders()}</>;
};

export const TableBodyComponent = ({
  tableData,
  selectedColumns,
  handleAction = () => {},
}) => {
  const createBody = () => {
    let rows = [];
    const { columns, data = [] } = tableData;

    if (data.length) {
      data?.forEach((itm, idx) => {
        let cells = [];
        let itmComponent;

        columns.forEach((column) => {
          if (selectedColumns.includes(column.name)) return; // use forearch
          itmComponent = itm[column.name] || '';
          if (column.type === 'email') {
            itmComponent = (
              <a className="text-primary" href={`mailto:${itmComponent}`}>
                {itmComponent}
              </a>
            );
          } else if (column.name === 'viewLink') {
            itmComponent = (
              <Rounded className="border border-fadedgrey p-4 w-[24px] h-[24px] flex items-center justify-center">
                <button
                  type="button"
                  className="cursor-pointer"
                  onClick={() => handleAction(itm, column.url)}
                >
                  <FileArrowDown className="stroke-black" />
                </button>
              </Rounded>
            );
          } else if (column.name === 'action') {
            itmComponent = (
              <Rounded className="border border-fadedgrey p-4 w-[24px] h-[24px] flex items-center justify-center">
                <button
                  type="button"
                  className="cursor-pointer"
                  onClick={() => handleAction(itm)}
                >
                  <FolderOpenIcon className="stroke-black stroke-1 fill-black " />
                </button>
              </Rounded>
            );
          }

          cells.push(
            <TableCell
              key={column.name}
              className={
                itmComponent === '-'
                  ? 'text-center text-body whitespace-nowrap'
                  : 'text-body whitespace-nowrap'
              }
            >
              {itmComponent}
            </TableCell>
          );
        });

        rows.push(<TableRow key={itm.id || idx}>{cells}</TableRow>);
      });
      return <TableBody>{rows}</TableBody>;
    }

    return (
      <TableBody>
        <TableRow>
          <TableCell
            className="text-body whitespace-nowrap text-center"
            colSpan="6"
          >
            Κανένα Αποτέλεσμα
          </TableCell>
        </TableRow>
      </TableBody>
    );
  };

  return <>{createBody()}</>;
};
